// extracted by mini-css-extract-plugin
module.exports = {"manage-button":"c-XxZ","manageButton":"c-XxZ"};